import { useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import { PageHeader } from "@/components/shared/PageHeader";
import { PrimaryButton, SecondaryButton } from "@/components/shared/Buttons";
import { useSeo } from "@/hooks/useSeo";

export default function PaymentFailed() {
  useSeo("Payment Failed", "Your ASAI payment could not be completed.");
  const [params] = useSearchParams();
  const ref = params.get("ref");

  return (
    <div data-testid="page-payment-failed">
      <PageHeader overline="Payment" titleLines={["Payment", "not completed"]} />
      <section className="bg-white py-20 md:py-28">
        <div className="container-asai max-w-xl">
          <div className="flex flex-col items-center gap-5 rounded-3xl border border-navy/10 bg-lightgrey p-8 text-center">
            <XCircle className="h-16 w-16 text-red-500" />
            <h2 className="font-heading text-2xl text-navy">Your payment was not completed</h2>
            <p className="text-sm text-navy/65">
              No amount has been deducted, or any deducted amount will be auto-refunded by your bank.
              {ref ? ` Reference: ${ref}.` : ""} You can try again or contact our team for help.
            </p>
            <div className="mt-2 flex flex-wrap justify-center gap-3">
              <PrimaryButton to="/payment" withArrow testId="failed-retry">Try Again</PrimaryButton>
              <SecondaryButton to="/contact" testId="failed-contact">Contact Support</SecondaryButton>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
